export default "__VITE_ASSET__BneQ6c4K__"